<template lang="html">
	<div
	id="home"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section1-container">
	<img class="single-image" src="@/assets/img/hero-image.png">
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section1-container {
	width: 80%;
	max-width: 800px;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.single-image {
	padding-top: 5vh;
	width:60%;
	max-width:300px;
}
    
</style>